// @ts-nocheck
import { ContactFormContext } from "@store/Overrides/Widgets/ContactUs/ContactForm";
import { useContext, useEffect } from "react";

const useFieldValidation = (key: string, value: string | undefined, validate: () => boolean) => {
    const contactFormContext = useContext(ContactFormContext);

    useEffect(() => {
        contactFormContext.validators[key] = validate;
        if (typeof value !== "undefined") {
            validate();
        }
    }, [value]);
};

export default useFieldValidation;
